export function snapToGrid(value: number, increment = 0.5): number {
  return Math.round(value / increment) * increment;
}

export function svgToBoard(px: number, scale: number): number {
  return px / scale;
}
